import { Component } from '@angular/core';
import { NgbCalendar, NgbDate, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-community';
import { QueovalDate } from '../../../models';
import { CustomDatepickerI18n, I18n, QueovalDateService } from '../../../services';


@Component({
  selector: 'agDatePicker',
  templateUrl: './agDatePicker.component.html',
  providers: [I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }] // define custom NgbDatepickerI18n provide
})


export class DatePickerEditor implements ICellEditorAngularComp {

  private params: ICellEditorParams;
  public selectedDate: NgbDate;
  public maxDate: NgbDate;
  public minDate: NgbDate;
  public noDate: boolean = false;

  constructor(
    public calendar: NgbCalendar,
    public qDateService: QueovalDateService
  ) {}

  selectToday() {
    const todayModel: NgbDate = this.calendar.getToday();
    this.selectedDate = new NgbDate(todayModel.year, todayModel.month, todayModel.day);
    this.params.api?.stopEditing();
  }

  selectNoDate() {
    this.noDate = true;
    this.params.api?.stopEditing();
  }

  agInit(params: any): void {

    this.params = params;
    // Applique la date du jour comme date max selectionnable
    if (this.params.colDef.cellEditorParams == 'MaxDateToday')
      this.maxDate = this.calendar.getToday();
    if (this.params.colDef.cellEditorParams == 'MinDateToday')
      this.minDate = this.calendar.getToday();

    if (this.params.value) {
      // Recuperation de la date
      const qDateToSelect: QueovalDate = this.qDateService.FromString(this.params.value.toString(), 'dd/MM/yyyy');
      const dateToSelect: Date | null = this.qDateService.ToDate(qDateToSelect);
      this.selectedDate = new NgbDate(dateToSelect!.getFullYear(), dateToSelect!.getMonth() + 1, dateToSelect!.getDate());
    }
   
  }


  getValue() {
    if (!this.selectedDate || this.noDate) {
      return null;
    } else {
      return [
        (this.selectedDate.day < 10 ? ('0' + this.selectedDate.day) : this.selectedDate.day),
        (this.selectedDate.month < 10 ? ('0' + this.selectedDate.month) : this.selectedDate.month),
        this.selectedDate.year
      ].join('/');
    }
  }


  isPopup(): boolean {
    return true;
  }


  onDateSelect(date: NgbDate) {
    this.selectedDate = date;
    this.params.api?.stopEditing();
  }

}

